import React from "react";
import JobsComponent from "./JobsComponent";
import PendingAmount from "./PendingAmount";
import MyLoader from "../HOC/MyLoader";
import { BrowserRouter } from "react-router-dom";
const AssignedComponent = (props) => {
  console.log("AssignedComponent", props);
  return (
    <div className="maincontent container">
      <PendingAmount />
      <JobsComponent jobsobject={props.jobs == "failure" ? [] : props.jobs} />
    </div>
  );
};

export default MyLoader(AssignedComponent, "assigned");



// WEBPACK FOOTER //
// ./src/components/Assigned/AssignedComponent.js